var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTravelSecurity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2060)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2060)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5462 19.25H23.4538C23.2017 19.25 23 19.4722 23 19.75C23 20.0278 23.2017 20.25 23.4538 20.25H25.5462C25.7983 20.25 26 20.0278 26 19.75C26 19.4722 25.7983 19.25 25.5462 19.25Z",
    fill: "#34D399"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3128 15.6463L25.5836 13.5005C24.9899 13.2817 24.0211 13.2817 23.4274 13.5005L17.6982 15.6463C16.5941 16.063 15.6982 17.3547 15.6982 18.5317V26.9692C15.6982 27.813 16.2503 28.9275 16.9274 29.4275L22.6565 33.7088C23.6669 34.4692 25.3232 34.4692 26.3336 33.7088L32.0628 29.4275C32.7399 28.9171 33.292 27.813 33.292 26.9692V18.5317C33.3025 17.3547 32.4065 16.063 31.3128 15.6463ZM30.9274 25.4692C30.9065 27.6255 30.3128 28.1671 28.0732 28.1671H20.9378C18.6566 28.1671 18.0837 27.6046 18.0837 25.3442V22.9171C18.0837 22.6255 18.3128 22.3963 18.6045 22.3963H30.4065C30.6982 22.3963 30.9274 22.6255 30.9274 22.9171V25.4692ZM30.9274 20.7401C30.9274 21.0317 30.6982 21.2609 30.4065 21.2609H18.6045C18.3128 21.2609 18.0837 21.0317 18.0837 20.7401V20.0734C18.0837 18.0317 18.5628 17.3755 20.3441 17.2609C20.5316 17.2609 20.7295 17.2505 20.9378 17.2505H28.0732C30.3544 17.2505 30.9274 17.813 30.9274 20.0734V20.7401Z",
    fill: "#34D399"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2060",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2060",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTravelSecurity);
export default __webpack_public_path__ + "static/media/icon-travel-security.5ce5c5fe57126d195751a3b043000a26.svg";
export { ForwardRef as ReactComponent };